import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InsightsLibraryReducer } from '.';
import { createItemSelectorSelectors } from '../item-selector/selectors';
import { InsightsLibraryPage, InsightsLibraryDashboard, InsightsLibraryDashboardCategory, InsightsLibraryVisual, InsightsLibraryVisualCategory } from './types';

export const featureSelector = createFeatureSelector<InsightsLibraryReducer.State>('insights-library');

export const isVisible = createSelector(
  featureSelector,
  state => state.visible
);


export const updating = createSelector(
  featureSelector,
  state => state.updating
);


export const loadingDashboards = createSelector(
  featureSelector,
  state => state.loadingDashboards
);

export const dashboards = createSelector(
  featureSelector,
  state => state.dashboards
);


export const loadingVisuals = createSelector(
  featureSelector,
  state => state.loadingVisuals
);

export const visuals = createSelector(
  featureSelector,
  state => state.visuals
);


export const page = createSelector(
  featureSelector,
  state => state.page
);

export const starredOnly = createSelector(
  featureSelector,
  state => state.starredOnly
);

export const filter = createSelector(
  featureSelector,
  state => state.filter
);


export const inViewMode = createSelector(
  featureSelector,
  state => state.viewMode
);


export const dashboardItemSelector =
  createItemSelectorSelectors<InsightsLibraryDashboard, InsightsLibraryDashboardCategory>('insights-library/dashboard-item-selector');

export const visualItemSelector =
  createItemSelectorSelectors<InsightsLibraryVisual, InsightsLibraryVisualCategory>('insights-library/visual-item-selector');
